import { LectureStatus } from '../lectures/lecture-status.type';

export enum AttendanceStatusDb {
  Attended = 'attended',
  Late = 'late',
  Missed = 'missed',
}

export interface CourseStudentAttendanceEntry {
  studentId: number;
  studentName: string;
  status: AttendanceStatusDb | null;
}

export interface CourseLectureAttendancePart {
  id: number;
  name: string;
  attendance: CourseStudentAttendanceEntry[];
}

export interface CourseLectureAttendanceReport {
  id: number;
  date: string;
  startTime: string;
  endTime: string;
  lectureSubject: string;
  lectureStatus: LectureStatus;
  parts: CourseLectureAttendancePart[];
}
